"use client";
import React, { useRef, useState } from "react";
import { Button } from "antd";
import { UploadOutlined } from "@ant-design/icons";
import { useTranslation } from "react-i18next";

import uploadIcon from "../../../assets/icons/Icon_upload.png";
import "./PrescriptionTab.css";

export default function PrescriptionTab({
  accept = ".pdf,.png,.jpg,.jpeg",
  onUpload, // (files: File[]) => void
  onCreatePrescription, // () => void (optionnel)
}) {
  const { t } = useTranslation();

  const inputRef = useRef(null);
  const [dragOver, setDragOver] = useState(false);

  const handleFiles = (fileList) => {
    const files = Array.from(fileList || []);
    if (!files.length) return;
    onUpload?.(files);
  };

  const onDrop = (e) => {
    e.preventDefault();
    setDragOver(false);
    handleFiles(e.dataTransfer.files);
  };

  return (
    <div className="apm-presc">
      {/* Head */}
      <div className="apm-presc-head">
        <h4 className="apm-presc-title">
          {t("prescriptionTab.head.title")}
        </h4>
        <p className="apm-presc-sub">
          {t("prescriptionTab.head.subtitleLine1")}
          <br />
          {t("prescriptionTab.head.subtitleLine2")}
        </p>
      </div>

      {/* Card */}
      <div className="apm-card">
        <div className="apm-card-grid">
          {/* Drop zone */}
          <div
            className={`apm-drop ${dragOver ? "is-over" : ""}`}
            onDragOver={(e) => {
              e.preventDefault();
              setDragOver(true);
            }}
            onDragLeave={() => setDragOver(false)}
            onDrop={onDrop}
            onClick={() => inputRef.current?.click()}
            role="button"
            tabIndex={0}
          >
            <div className="apm-drop-inner">
              <img
                src={uploadIcon}
                alt={t("prescriptionTab.drop.alt")}
                className="apm-drop-img"
              />
              <div className="apm-drop-sub">
                {t("prescriptionTab.drop.hint")}
              </div>
            </div>

            <input
              ref={inputRef}
              type="file"
              accept={accept}
              multiple
              hidden
              onChange={(e) => handleFiles(e.target.files)}
            />
          </div>

          {/* Right info */}
          <div className="apm-card-info">
            <div className="apm-card-title">
              {t("prescriptionTab.card.title")}
            </div>

            <p className="apm-card-desc">
              {t("prescriptionTab.card.descLine1")}
              <br />
              {t("prescriptionTab.card.descLine2")}
            </p>

            <div className="apm-actions">
              <Button
                type="primary"
                icon={<UploadOutlined />}
                onClick={() => inputRef.current?.click()}
              >
                {t("prescriptionTab.card.uploadBtn")}
              </Button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
